module.exports = __webpack_public_path__ + "svg/new-swish.168b15412d4d2de442709b5ac7a7cb2f.svg";